export default "__VITE_ASSET__CdKAUsCO__"